// features/spark/scripts/static-generate.ts 로 생성된 파일입니다.
// next.js 에서 이 파일을 복사해서 사용하면 됩니다.
import tradedesktop960 from '@flipster/features/static/spark/reward/trade_desktop_960_1x.webp';
import tradedesktop1920 from '@flipster/features/static/spark/reward/trade_desktop_960_2x.webp';
import trade from '@flipster/features/static/spark/reward/trade_mobile_360_1x.webp';
import trademobile360 from '@flipster/features/static/spark/reward/trade_mobile_360_1x.webp';
import trademobile720 from '@flipster/features/static/spark/reward/trade_mobile_360_2x.webp';
import trademobile420 from '@flipster/features/static/spark/reward/trade_mobile_420_1x.webp';
import trademobile840 from '@flipster/features/static/spark/reward/trade_mobile_420_2x.webp';
import trademobile768 from '@flipster/features/static/spark/reward/trade_mobile_768_1x.webp';
import trademobile1536 from '@flipster/features/static/spark/reward/trade_mobile_768_2x.webp';

export default {
  img: {
    src: trade.src,
    width: 360,
    height: 307,
    alt: 'How to gain sparks',
  },
  sources: [
    {
      media: '(max-width: 767px)',
      srcSet: [
        `${trademobile360.src} 360w`,
        `${trademobile720.src} 720w`,
        `${trademobile420.src} 420w`,
        `${trademobile840.src} 840w`,
        `${trademobile768.src} 768w`,
        `${trademobile1536.src} 1536w`,
      ].join(', '),
      sizes: '100vw',
    },
    {
      srcSet: [`${tradedesktop960.src} 960w`, `${tradedesktop1920.src} 1920w`].join(', '),
      sizes: '960px',
    },
  ],
};
